import { Card, CardContent, CardHeader, Container, Grid, TextField, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router'
import Collapse from '../../components/Collapse/Collapse';
import FloatingAction from '../../components/FloatingAction/FloatingAction';
import FormattedEditor from '../../components/FormattedEditor/index';

import Selector from '../../components/Selector/Selector'
import { PRODUCT_ACTIONS } from '../../redux/actions';
import NavigationIcon from '@material-ui/icons/Save';
import FloatingActionList from '../../components/FloatingAction/FloatingActionList';
export const ProductDetails = () => {

    const { id } = useParams()

    const dispatch = useDispatch()
    const product = useSelector(state => state.products.product)
    const getProductById = (id) => dispatch(PRODUCT_ACTIONS.getProductById(id))

    const [t, i18n] = useTranslation('common');

    useEffect(() => {
        //getProductById(id)
    }, [id])

    return (
        <Container maxWidth="xl" disableGutters >
            <FloatingActionList orientation="horizontal" >
                <FloatingAction onActionClick={(id)=>console.log("inaction",id)} id="action_1" iconComponent={NavigationIcon} color="primary" variant="expanded" text="save data" />
                <FloatingAction id="action_2" iconComponent={NavigationIcon} color="secondary" variant="expanded" text="save data" />
                <FloatingAction id="action_3" iconComponent={NavigationIcon} variant="expanded" text="save data" />
            </FloatingActionList>

            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Collapse title={t('product.title.general')} >
                        <Grid container spacing={2}>
                            <Grid item xs={6} lg >
                                <TextField
                                    fullWidth
                                    value={product.name}
                                    label={t('product.input.label.name')}
                                    variant="outlined" />
                            </Grid>
                            <Grid item xs={6} lg={4} >
                                <TextField
                                    fullWidth
                                    value={product.slug}
                                    label={t('product.input.label.slug')}
                                    variant="outlined" />
                            </Grid>
                            <Grid item xs={6} lg={2} >
                                <Selector
                                    value={product.status}
                                    options={[
                                        { label: "Published", value: "publish" },
                                        { label: "Private", value: "private" },
                                        { label: "Draft", value: "draft" },
                                        { label: "Pending", value: "pending" },
                                    ]}
                                />
                            </Grid>
                        </Grid>
                    </Collapse>
                </Grid>
                <Grid item xs={12}>
                    <Collapse title={t('product.title.description')}>
                        <FormattedEditor text={product.description} />
                    </Collapse>
                </Grid>
                <Grid item xs={12}>
                    <Collapse title={t('product.title.short_description')}>
                        <FormattedEditor text={product.short_description} />
                    </Collapse>
                </Grid>
            </Grid>
        </Container>
    )
}
